goog.provide("shadow.js.shim.module$react_bootstrap$Fade$default");
shadow.js.shim.module$react_bootstrap$Fade$default = shadow.js.require(56, {})["default"];
